interface BrandMarkProps {
  compact?: boolean;
}

export function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <div className={`brand-mark${compact ? " brand-mark--compact" : ""}`} aria-label="Air Hockey Arena">
      <span className="brand-mark__icon" aria-hidden="true">
        <span />
      </span>
      <span className="brand-mark__word">
        <strong>AIR</strong>
        <span>HOCKEY</span>
      </span>
      {!compact && <em>ARENA</em>}
    </div>
  );
}
